webpackJsonp([114276838955818],{

/***/ 604:
/***/ (function(module, exports) {

	module.exports = {"data":{"allContentJson":{"edges":[{"node":{"baseTitle":"InsideOut"}}]}},"layoutContext":{}}

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(1031);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(604);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeaderSimple = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerManager = __webpack_require__(31);
	
	var _link = __webpack_require__(9);
	
	var _logo = __webpack_require__(431);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _logoMobile = __webpack_require__(765);
	
	var _logoMobile2 = _interopRequireDefault(_logoMobile);
	
	var _arrowIcon = __webpack_require__(171);
	
	var _arrowIcon2 = _interopRequireDefault(_arrowIcon);
	
	var _arrowIconLarge = __webpack_require__(778);
	
	var _arrowIconLarge2 = _interopRequireDefault(_arrowIconLarge);
	
	var _headersimple = __webpack_require__(997);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderSimple = exports.HeaderSimple = function (_React$PureComponent) {
		_inherits(HeaderSimple, _React$PureComponent);
	
		function HeaderSimple() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, HeaderSimple);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				back: true,
				subheader: null,
				cta: null
			}, _this.componentDidMount = function () {
				_headerManager.HeaderManager.subscribe(_this.handleStateUpdate);
			}, _this.componentWillUnmount = function () {
				_headerManager.HeaderManager.unsubscribe(_this.handleStateUpdate);
			}, _this.handleStateUpdate = function (newState) {
				_this.setState(newState);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		HeaderSimple.prototype.render = function render() {
			var _state = this.state,
			    subheader = _state.subheader,
			    cta = _state.cta,
			    back = _state.back;
	
	
			return _react2.default.createElement(
				'div',
				{ 'data-component': 'HeaderSimple', className: _headersimple.wrapperStyle },
				_react2.default.createElement(
					'div',
					{ className: _headersimple.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: (0, _headersimple.logoAndBackStyle)(back) },
						back && _react2.default.createElement(
							'span',
							{ className: _headersimple.backArrowStyle },
							_react2.default.createElement(
								'a',
								{ onClick: _link.goBack },
								_react2.default.createElement(_arrowIconLarge2.default, { fill: _globalStyles.aqua, width: 24, height: 24 })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _headersimple.headerStyle },
							_react2.default.createElement(
								_link.Link,
								{ to: '/', className: _headersimple.logoLinkStyle },
								_react2.default.createElement(
									'span',
									{ className: _headersimple.logoStyle },
									_react2.default.createElement('img', {
										id: 'logoDesktop',
										src: _logo2.default,
										alt: 'Inside Out : Institute for Eating Disorders'
									}),
									_react2.default.createElement('img', {
										id: 'logoMobile',
										src: _logoMobile2.default,
										alt: 'Inside Out : Institute for Eating Disorders'
									})
								)
							),
							subheader && _react2.default.createElement(
								'p',
								{ className: _headersimple.subheaderStyle },
								subheader
							)
						)
					),
					cta && _react2.default.createElement(
						'div',
						{ className: _headersimple.ctaStyle },
						cta.question && _react2.default.createElement(
							'p',
							null,
							cta.question
						),
						_react2.default.createElement(
							_link.Link,
							{ to: cta.callToAction.to },
							cta.callToAction.name,
							' ',
							_react2.default.createElement(_arrowIcon2.default, { fill: 'inherit' })
						)
					)
				)
			);
		};
	
		return HeaderSimple;
	}(_react2.default.PureComponent);

/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.logoStyle = exports.innerWrapperStyle = exports.ctaStyle = exports.headerStyle = exports.logoLinkStyle = exports.subheaderStyle = exports.backArrowStyle = exports.logoAndBackStyle = exports.wrapperStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css, _css2, _css3, _css4;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)((_css = {
		height: '100px',
		background: '#F6F6F6',
		position: 'relative'
	}, _css['@media(max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		height: 'auto'
	}, _css));
	
	var logoAndBackStyle = exports.logoAndBackStyle = function logoAndBackStyle(back) {
		var _ref, _ref2, _extends2;
	
		return (/*#__PURE__*/(0, _emotion.css)(_extends({
				display: 'flex',
				alignItems: 'center',
				position: 'relative'
			}, back ? (_ref2 = {}, _ref2['& .' + backArrowStyle] = {
				position: 'absolute',
				left: '-44px'
			}, _ref2['@media screen and (max-width: ' + (_globalStyles.desktopMaxWidthBreakpoint + 64) + 'px)'] = (_ref = {}, _ref['& .' + backArrowStyle] = {
				position: 'relative',
				left: '0',
				marginRight: '20px'
			}, _ref), _ref2) : null, (_extends2 = {}, _extends2['@media(max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
				padding: '10px 0'
			}, _extends2)))
		);
	};
	
	var backArrowStyle = /*#__PURE__*/exports.backArrowStyle = (0, _emotion.css)({
		'& svg': {
			transform: 'rotate(180deg)'
		},
		'@media print': {
			display: 'none'
		}
	});
	
	var subheaderStyle = /*#__PURE__*/exports.subheaderStyle = (0, _emotion.css)({
		color: _globalStyles.grey,
		fontSize: '10px',
		fontWeight: 'bold',
		padding: '0 0 0 20px',
		textDecoration: 'none',
		textTransform: 'uppercase'
	});
	
	var logoLinkStyle = /*#__PURE__*/exports.logoLinkStyle = (0, _emotion.css)({});
	
	var baseHeaderStyle = {
		display: 'flex',
		alignItems: 'center'
	};
	
	var headerStyle = /*#__PURE__*/exports.headerStyle = (0, _emotion.css)(baseHeaderStyle);
	
	var ctaStyle = /*#__PURE__*/exports.ctaStyle = (0, _emotion.css)((_css2 = {
		color: _globalStyles.grey,
		fontSize: '14px',
		lineHeight: '17px',
		display: 'flex',
		alignItems: 'center',
		'& p': {
			margin: '0 24px 0 0'
		},
		'& a': {
			fontWeight: 'bold',
			color: _globalStyles.pink,
			fontSize: '14px',
			lineHeight: '17px',
			textDecoration: 'none',
			'& svg': {
				marginLeft: '10px'
			}
		}
	}, _css2['@media(max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		padding: '10px 0',
		justifyContent: 'flex-start'
	}, _css2['@media(max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& p, & a': {
			fontSize: '10px',
			lineHeight: '12px'
		},
		'& p': {
			maxWidth: '130px',
			marginRight: '12px'
		}
	}, _css2['@media print'] = {
		display: 'none'
	}, _css2));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)((_css3 = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		margin: '0 auto',
		padding: '0 20px',
		height: '100%',
		display: 'flex',
		justifyContent: 'space-between'
	}, _css3['@media screen and (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		justifyContent: 'flex-start',
		flexDirection: 'column'
	}, _css3['@media(max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		padding: '0 10px'
	}, _css3));
	
	var logoStyle = /*#__PURE__*/exports.logoStyle = (0, _emotion.css)((_css4 = {
		'& #logoDesktop': {
			width: '158px',
			height: '54px'
		},
		'& #logoMobile': {
			display: 'none',
			height: '37px',
			width: '28px'
		}
	}, _css4['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& #logoDesktop': {
			display: 'none'
		},
		'& #logoMobile': {
			display: 'block'
		}
	}, _css4));

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _headersimple = __webpack_require__(996);
	
	Object.keys(_headersimple).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _headersimple[key];
	    }
	  });
	});

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNiAzNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHRpdGxlPkluc2lkZSBPdXQgOiBJbnN0aXR1dGUgZm9yIEVhdGluZyBEaXNvcmRlcnMgTG9nbzwvdGl0bGU+CjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNSAtOSkiIGZpbGw9IiNGMDVCNUUiPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgNykiPgo8cGF0aCBkPSJtMjIuODQ5IDEyLjcyNmMtMC4wMDM2NjIyLTIuNzcxMy0xLjY4MTgtNC45MTk0LTQuMTUwMS01LjMxMjMtNC4xMTI2LTAuNjU0MzctNy4xNTg2IDIuNjUwOS02LjE4OTUgNi43MTQyIDAuNTkxODkgMi40ODE3IDIuMzA0OSA0LjEwMzMgNC40NjkyIDQuMjMwOCAzLjU0NjggMC4yMDkxOSA1Ljg3NTQtMi4wMjUxIDUuODcwNC01LjYzMjdtNy4zNzg3IDAuMDAyMTk3M2MtMC4wMDI3NDY2IDYuODkzNS01LjQzODcgMTIuMDU0LTEyLjY1NSAxMi4wMTUtNy4yMjI2LTAuMDM5OTkyLTEyLjU2Ny01LjEzMDgtMTIuNTczLTExLjk3Ny0wLjAwNjg2NjUtNi43ODcyIDUuMzEyNC0xMS43NTkgMTIuNTg5LTExLjc2NiA3LjI3NTctMC4wMDcwMzE1IDEyLjY0MSA0Ljk3MTcgMTIuNjM4IDExLjcyOSIvPgo8cGF0aCBkPSJtMTcuNzIgMzQuMzYyYy0xLjQ3NDUgMC0yLjk1IDAuMDI0NTg3LTQuNDIzMi0wLjAwNjc0MTYtMS41MjcyLTAuMDMyNTE4LTIuMTg5Ni0wLjYzMDE0LTIuMjY3Mi0xLjk1NjMtMC4xNzI2Mi0yLjk0NDEgMC4zMTkzNS0zLjM5MyAzLjcyMjctMy4zOTMgMi4zODE3IDMuOTY1ZS00IDQuNzYzOS0wLjAxOTAzNSA3LjE0NTYgMC4wMDk1MTc2IDIuMDY5NiAwLjAyNDE5IDIuNTg0OCAwLjUxMjM2IDIuNTkzNCAyLjMyODIgMC4wMTQwODIgMi43OTc0LTAuMjQ0MzkgMy4wMjE4LTMuNDgxOSAzLjAyMjItMS4wOTY2IDMuOTY1ZS00IC0yLjE5MjcgMC0zLjI4OTMgMHYtMC4wMDM5NjU3eiIvPgo8L2c+CjwvZz4KPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.8c297635.svg";

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _index = __webpack_require__(1032);
	
	var _headerSimple = __webpack_require__(998);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This is "Simple Layout"
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Gatsby enforces this to be index.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	// Gatsby requires a default export here.
	var SimpleLayout = function (_React$PureComponent) {
		_inherits(SimpleLayout, _React$PureComponent);
	
		function SimpleLayout() {
			_classCallCheck(this, SimpleLayout);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		SimpleLayout.prototype.render = function render() {
			var baseTitle = this.props.data.allContentJson.edges[0].node.baseTitle;
	
	
			return _react2.default.createElement(
				'div',
				{ className: _index.wrapperStyle },
				_react2.default.createElement(_reactHelmet.Helmet, { titleTemplate: baseTitle + ' - %s' }),
				_react2.default.createElement(_headerSimple.HeaderSimple, null),
				this.props.children()
			);
		};
	
		return SimpleLayout;
	}(_react2.default.PureComponent);
	
	SimpleLayout.propTypes = {
		children: _propTypes2.default.func.isRequired,
		data: _propTypes2.default.shape({
			allContentJson: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						baseTitle: _propTypes2.default.string
					})
				}))
			})
		})
	};
	exports.default = SimpleLayout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapperStyle = undefined;
	
	var _emotion = __webpack_require__(6);
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)({
		width: '100%'
	});

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-596fc184270fb57bef1f.js